var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4,60.5c0.5,0.6,0.5,1.6-0.1,2.1s-1.6,0.5-2.1-0.1c-2-2.3-4.9-3.6-7.9-3.6c-3.1,0-6,1.4-8,3.7c-0.3,0.3-0.7,0.5-1.1,0.5  c-0.3,0-0.7-0.1-1-0.4c-0.6-0.5-0.7-1.5-0.2-2.1c2.6-3,6.3-4.8,10.3-4.8C59.2,55.9,62.9,57.6,65.4,60.5z M55.3,43.5  c-7.1,0-14,3.1-18.9,8.4c-0.6,0.6-0.5,1.6,0.1,2.1c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5c4.3-4.7,10.3-7.4,16.6-7.4  c6.3,0,12.1,2.6,16.4,7.2c0.6,0.6,1.5,0.6,2.1,0.1c0.6-0.6,0.6-1.5,0.1-2.1C69,46.4,62.4,43.5,55.3,43.5z M60.7,34.6  c0.8,0.1,1.6-0.4,1.7-1.2c0.1-0.8-0.4-1.6-1.2-1.7c-1.9-0.3-3.9-0.5-5.9-0.5c-10.5,0-20.3,4.3-27.5,12.1c-0.6,0.6-0.5,1.6,0.1,2.1  c0.3,0.3,0.7,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5c6.6-7.2,15.6-11.2,25.3-11.2C57.1,34.2,58.9,34.3,60.7,34.6z M60.5,22.1  c0.8,0.1,1.6-0.5,1.7-1.3c0.1-0.8-0.5-1.6-1.3-1.7c-1.8-0.2-3.7-0.3-5.6-0.3c-13.6,0-26.2,5.5-35.7,15.4c-0.6,0.6-0.5,1.5,0,2.1  c0.3,0.3,0.7,0.4,1,0.4c0.4,0,0.8-0.2,1.1-0.5c8.9-9.3,20.8-14.4,33.5-14.4C57,21.8,58.8,21.9,60.5,22.1z M61.8,74.7  c0,3.6-2.9,6.5-6.5,6.5s-6.5-2.9-6.5-6.5s2.9-6.5,6.5-6.5S61.8,71.1,61.8,74.7z M58.8,74.7c0-1.9-1.6-3.5-3.5-3.5s-3.5,1.6-3.5,3.5  s1.6,3.5,3.5,3.5S58.8,76.7,58.8,74.7z M74.3,31.6c-1.9,0-3.5-1.1-3.5-2.3s1.6-2.3,3.5-2.3s3.5,1.1,3.5,2.3c0,0.8,0.7,1.5,1.5,1.5  s1.5-0.7,1.5-1.5c0-2.5-2.1-4.6-5-5.1v-1.1c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5v1.1c-2.9,0.5-5,2.6-5,5.1c0,2.9,2.9,5.3,6.5,5.3  c1.9,0,3.5,1.1,3.5,2.3s-1.6,2.3-3.5,2.3s-3.5-1.1-3.5-2.3c0-0.8-0.7-1.5-1.5-1.5s-1.5,0.7-1.5,1.5c0,2.5,2.1,4.6,5,5.1v1.1  c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5V42c2.9-0.5,5-2.6,5-5.1C80.8,34,77.9,31.6,74.3,31.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwif);
export default __webpack_public_path__ + "static/media/PWIF.6670a53cfab8ca08ca2382cd9f4f3a7e.svg";
export { ForwardRef as ReactComponent };